import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Le filet de sécurité.
 *
 * Sans lui, la moindre erreur pendant un rendu — une clé mal orthographiée, une
 * donnée inattendue — démonte toute l'application et l'utilisateur se retrouve
 * devant une PAGE BLANCHE. Pas un message : du blanc. C'est exactement ce qui
 * s'est produit sur l'écran Analytique avec une clé accentuée par erreur.
 *
 * Une page blanche fait croire que les données sont perdues. Elles ne le sont
 * jamais : rien n'est écrit côté serveur pendant un rendu.
 */
interface Props { children: ReactNode }
interface State { erreur: Error | null }

export class Filet extends Component<Props, State> {
  state: State = { erreur: null };

  static getDerivedStateFromError(erreur: Error): State {
    return { erreur };
  }

  componentDidCatch(erreur: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[écran] rendu impossible —', erreur, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.erreur) return this.props.children;
    return (
      <div style={{ maxWidth: 560, margin: '48px auto', padding: '0 20px' }}>
        <div className="carte carte-p">
          <h2 style={{ marginBottom: 8 }}>Cet écran n'a pas pu s'afficher</h2>
          <p style={{ color: 'var(--texte2)' }}>
            <b>Vos données ne sont pas perdues.</b> Rien n'a été modifié : cette erreur s'est
            produite en affichant la page, pas en enregistrant.
          </p>
          <p style={{ color: 'var(--texte2)', marginTop: 10 }}>
            Vous pouvez continuer à travailler sur les autres écrans. Si le problème revient,
            signalez-le en indiquant sur quel écran vous étiez.
          </p>
          <div className="actions" style={{ marginTop: 16 }}>
            <button className="btn btn-p" onClick={() => { window.location.href = '/'; }}>
              Revenir à Aujourd'hui
            </button>
            <button className="btn" onClick={() => window.location.reload()}>Réessayer</button>
          </div>
          <details style={{ marginTop: 14 }}>
            <summary className="mini sourdine" style={{ cursor: 'pointer' }}>Détail technique</summary>
            <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', color: 'var(--texte3)', marginTop: 8 }}>
              {this.state.erreur.message}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
